module.exports = __webpack_public_path__ + "img/firefox_lock.b10c0993.png";